<template>
  <li
    class="language-select lng_select"
    @focusout="openlangDropdown = false"
    tabindex="-2"
  >
    <h4 class="select-title" @click="openlanguage()">
      <span>{{ currentLanguageFullName }}</span>
      <svg width="12" height="6" fill="none">
        <use class="down-arrow" xlink:href="#downArrow" />
      </svg>
    </h4>
    <ul class="language-dropdown" :class="{ open: openlangDropdown }">
      <li
        v-for="language in availableLanguages"
        :key="language.id"
        :class="[currentLanguage == language.code ? 'active' : '']"
        @click="setLanguage(language.code)"
      >
        <h4>
          {{ _T_DB(language, 'name') }}
        </h4>
      </li>
    </ul>
  </li>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NotLoggedInNav',
  data() {
    return {
      openlangDropdown: false,
      classicheader: ['faq'],
    }
  },
  methods: {
    setLanguage(langCode) {
      this.$store.dispatch('setCurrentLanguage', langCode)
      this.openlangDropdown = false
    },
    openlanguage() {
      this.openlangDropdown = !this.openlangDropdown
    },
  },
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'currentLanguage',
      'availableLanguages',
      'currentLanguageFullName',
    ]),
    classicHeader() {
      if (
        this.$route.matched.some(({ name }) =>
          this.classicheader.includes(name)
        )
      ) {
        return true
      }
      return false
    },
  },
}
</script>
<style lang="scss" scoped>
.header-section {
  .menu-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    li {
      position: relative;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      &:first-child {
        padding-left: 0;
        &:after {
          display: none;
        }
      }
      &:last-child {
        padding-right: 0;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        height: 1.875rem;
        width: 0.063rem;
        background-color: $light-border;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .language-select {
      position: relative;
      .select-title {
        line-height: 1.125rem;
        color: $font-color;
        text-transform: capitalize;
        font-weight: 600;
        cursor: pointer;
        margin-bottom: 0;
        font-size: 1rem;
        svg {
          margin-left: $px5;
        }
      }
      .language-dropdown {
        position: absolute;
        top: 0.75rem;
        right: 0;
        background-color: $white;
        width: 10.625rem;
        box-shadow: 0 $px3 $px15 rgba($black, 0.1);
        padding: 0.75rem 0.313rem;
        opacity: 0;
        visibility: hidden;
        transition: all 0.5s ease;
        z-index: 99;
        li {
          display: flex;
          align-items: center;
          padding: 0.5rem 0.625rem;
          border-radius: 0.125rem;
          cursor: pointer;
          transition: all 0.5s ease;
          img,
          svg {
            width: 1.125rem;
            margin-right: 0.938rem;
          }
          &:after {
            display: none;
          }
          h4 {
            margin-bottom: 0;
            text-transform: capitalize;
            font-weight: 500;
            font-size: 1rem;
          }
          &.active {
            h4 {
              color: $color-primary;
              transition: all 0.5s ease;
              font-weight: 600;
            }
          }
          &:hover {
            background: $color-primary;
            color: $white;
            transition: all 0.5s ease;
          }
        }
        &.open {
          opacity: 1;
          visibility: visible;
          top: 1.875rem;
          transition: all 0.5s ease;
        }
      }
      &.country-select {
        .select-title {
          img {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 100%;
          }
        }
      }
    }
  }
}
.body-rtl {
  .language-select {
    h4 {
      svg {
        margin-left: unset;
        margin-right: $px5;
      }
    }
  }
}
@media (max-width: 460px) {
  .header-section {
    .menu-right {
      .language-select {
        .select-title {
          font-size: $px12;
        }
      }
    }
  }
}
</style>
